var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195 27",
    width: 150,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.3.07l-11.26,24.01h4.16l2.19-4.76h9.55l2.19,4.76h4.44L29.31.07h0Zm-3.23,15.6l3.1-6.82,3.1,6.82h-6.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.29.07l-11.26,24.01h4.16l2.19-4.76h9.55l2.19,4.76h4.44L134.3.07h0Zm-3.23,15.6l3.1-6.82,3.1,6.82h-6.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.27,12.31c0,7.31,4.91,12.23,11.83,12.23,3.46,0,6.16-.82,8.02-2.16v-4.33c-2.12,1.83-4.69,2.69-7.61,2.69-4.69,0-8.23-3.19-8.23-8.4,0-4.68,3.26-8.47,8.29-8.47,2.84,0,5.54,1.02,7.55,2.61V2.15c-1.87-1.29-4.34-2.08-7.49-2.08-7.53,0-12.36,5.47-12.36,12.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.35,14.58c0,2.17-.33,3.55-1.48,4.7-.96.95-2.36,1.46-4.19,1.46s-3.23-.51-4.19-1.46c-1.16-1.15-1.48-2.53-1.48-4.7V.54h-4.02v13.85c0,3.47.59,5.61,2.34,7.47,1.65,1.75,4.14,2.68,7.35,2.68s5.7-.93,7.35-2.68c1.75-1.85,2.34-4,2.34-7.47V.54h-4.02v14.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m192.21,4.38c-2.34-2.66-5.26-3.84-10.08-3.84h-6.79v23.53h6.79c4.81,0,7.74-1.18,10.08-3.84,1.83-2.08,2.79-4.66,2.79-7.92s-.96-5.85-2.79-7.92Zm-3.46,13.68c-1.51,1.52-3.43,2.24-6.18,2.24h-3.21V4.31h3.21c2.75,0,4.67.72,6.18,2.24,1.45,1.46,2.24,3.37,2.24,5.76s-.79,4.3-2.24,5.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.43,12.81c1.44-1.31,2.15-3.09,2.15-5.22s-.73-3.96-2.17-5.27c-1.44-1.31-3.11-1.78-5.94-1.78h-8.15v23.53h4.02v-9.43h2.96s.09,0,.14,0l7.48,9.43h4.87l-7.9-9.86c.99-.3,1.82-.75,2.54-1.41Zm-10.09-1.83v-6.65h4.68c2.2,0,3.73,1.05,3.73,3.32s-1.53,3.32-3.73,3.32h-4.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.79,12.92c0,2.41-.47,4.26-1.93,5.75-1.61,1.65-3.51,2.11-7.01,2.11H0v3.77h1.62c5.29,0,7.96-.89,10.27-3.17,2.3-2.27,2.92-4.87,2.92-9V.54h-4.02v12.38Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.46,12.31c0-6.88-5.35-12.24-12.2-12.24s-12.2,5.36-12.2,12.24,5.35,12.24,12.2,12.24c2.54,0,4.87-.74,6.8-2.01l4.41,4.41,2.58-2.58-4.29-4.29c1.7-2.1,2.7-4.79,2.7-7.77Zm-12.2,8.44c-4.59,0-8.19-3.71-8.19-8.44s3.6-8.44,8.19-8.44,8.19,3.71,8.19,8.44c0,1.86-.56,3.57-1.52,4.95l-5.17-5.17-2.58,2.58,5.05,5.05c-1.17.66-2.52,1.03-3.98,1.03Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee2a0f63.svg";
export { ForwardRef as ReactComponent };